<template>
  <div id="my-scroll" class="designated-area">
    <van-nav-bar title="设备消息" :fixed="true" left-text="返回" :border="true" left-arrow @click-left="backPage" />
    <div v-if="!deviceAlarmList || deviceAlarmList.length<=0" class="address-content">
      <img class="address-img" src="@/assets/images/address_list.png" background-size="cover" />
      <p class="address-txt">暂无数据</p>
    </div>
    <div v-else>
      <div class="designated-cotent" v-for="(item,index) in deviceAlarmList" :key="index">
        <div class="cotent-box">
          <i class="cotent-circle"></i>
          <p>{{item.date}}</p>
        </div>
        <div class="cotent-card" v-for="(val,ind) in item.list" :key="ind">
          <p class="designated-time" :style="{'color':val.alarmType=='1'?'#FC4D56':'#111111'}">{{val.alarmMsg}}</p>
          <p class="designated-addr">设备IMEI：{{val.imei?val.imei:'无'}}</p>
          <img class="cotent-c-img" :src="imageObj[val.alarmType]" background-size="cover" />
          <span class="cotent-c-time">{{val.time}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { formatTime } from '@/utils/index'
// import card from '@/components/card'

export default {
  components: {
    // card
  },

  data () {
    return {
      type:'',//消息类型
      imageObj:{
        16:require('@/assets/images/jing_msg.png'),
        17:require('@/assets/images/chu_msg.png'),
        'in_fence':require('@/assets/images/jing_msg.png'),
        'out_fence':require('@/assets/images/chu_msg.png'),
        'offline':require('@/assets/images/jinggao.png'),
        20:require('@/assets/images/kaiji_msg.png'),
        21:require('@/assets/images/zhong_yellow.png'),
        23:require('@/assets/images/jinggao.png'),
        1:require('@/assets/images/jinggao.png'),
        2:require('@/assets/images/shebei_msg.png'),
      },
      deviceAlarmList:[],
      page:1,
      pageSize:10,
    }
  },
  created () {
    this.type = this.$route.query.data
    this.getDevAlarmList()
    window.addEventListener('scroll', this.onScroll);
  },
  methods:{
    /**
    * 返回上一级
    */
    backPage() {
        this.$router.back(-1);
    },
    /**
     * 获取消息列表
     */
    getDevAlarmList(){
      let data = {
        ver:1,
        method:'getAlarmList',
        type:this.type,
        page:this.page,
        pageSize:this.pageSize
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          this.overflag = true;
          if (res.code === 0) {
            if(this.page==1){
              this.deviceAlarmList = []
            }
            if(!res.data){
              this.overflag = false;
              this.$toast("已经没有更多数据了!")
              return
            }
            this.deviceAlarmList = this.deviceAlarmList.concat(res.data.list)
          } else {
            this.$toast({
                message: res.msg,
                duration: 2000,
                icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },  
    /**
     * 滚动事件
     */
    onScroll() {
        // this.cagetime = setInterval(() => {
        //可滚动容器的高度
        let innerHeight = document.querySelector('#my-scroll') && document.querySelector('#my-scroll').clientHeight;
        //屏幕尺寸高度
        let outerHeight = document.documentElement.clientHeight || window.innerHeight;
        //可滚动容器超出当前窗口显示范围的高度
        let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，接近底部时就去做你该做的事。
        if (innerHeight < (outerHeight + scrollTop) + 55) {
            if (this.overflag) {
                this.overflag = false;
                this.page++;
                this.getDevAlarmList();
            }
        }

    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style  lang='scss' scoped>
.designated-area{
  background: #F8F8F8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120px 0 50px;
}
.designated-cotent{
  margin-left: 120px;
  border-left: 3px solid #e5e5e5;
}
.designated-cotent:nth-child(n+2){
  padding-top: 70px;
}
.cotent-box{
  display: flex;
  position: relative;
  margin-bottom: 65px;
}
.cotent-box>p{
  margin-left: 33px;
  font-size: 28px;
  font-weight: 600;
  color: #111111;
}
.cotent-circle{
  width: 26px;
  height: 26px;
  background: #FFA82D;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: -14px;
}
.cotent-card{
  width: 500px;
  background: #fff;
  border-radius: 20px;
  margin: 70px 0 0 50px;
  display: flex;
  padding: 20px 35px;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.designated-time{
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 30px;
}
.designated-addr{
  font-size: 24px;
  font-weight: 400;
  color: #999999;
}
.cotent-card .cotent-c-img{
  position: absolute;
  left: -78px;
  top: 0;
  width: 54px;
  height: 54px;
}
.cotent-c-time{
  font-size: 24px;
  font-family: ArialMT;
  color: #999999;
  position: absolute;
  left: -150px;
  top: 10px;
}
.address-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 300px;
  font-size: 28px;
  font-weight: 400;
  color: #999999;
}
.address-img{
  width: 426px;
  height: 230px;
}
.address-txt{
  margin-top: 50px;
}
</style>
<style lang="scss">
.designated-area{
    .van-nav-bar{
        background-color: #F8F8F8;
        width: 100%;
    }
}
</style>
